<template>
  <div id="app" class="bg-grey min-h-screen leading-normal" :class="templateClasses">
    <AppBanner />
    <header v-if="!isInsiteApp" class="headbg" :class="{ 'loggedin': isLoggedIn && !isCustomerWebsite }">
      <nav class="contentLimiter w-full flex items-center justify-between flex-wrap p-2 lg:p-4" :class="{ 'p-4 lg:p-8': isCustomerWebsite }">
        <div class="flex justify-between items-center flex-no-shrink text-white mr-6" :class="{ 'w-full': !isCustomerWebsite }">
          <router-link tag="div" :to="{ path: '/' }" role="button" aria-label="zur Startseite" class="logolink font-semibold text-xl tracking-tight" tabindex="-1">
            <span v-if="!site.logo">{{ logoTitle }}</span>
            <img v-if="site.logo" class="heinzlogo" :src="site.logo" />
          </router-link>
          <div v-if="isCustomerWebsite" class="text-xs pl-2 sm:pl-4">{{ logoText }}</div>
          <div v-if="!isCustomerWebsite && !isPosApp" class="flex">
            <a v-if="!isLoggedIn" v-on:click="userLogin()" class="btn btn-login" title="Anmelden" role="button" aria-label="Anmelden"></a>
            <template v-else>
              <router-link tag="a" :to="{ path: '/einstellungen' }" class="btn btn-settings" title="Einstellungen"></router-link>
              <a href="javascript:void(0)" v-on:click="userLogout()" class="btn btn-logout" title="Logout"></a>
            </template>
          </div>
        </div>
        <div v-if="isCustomerWebsite" class="block lg:hidden">
          <button v-on:click="toggleMenu" class="flex hidden items-center px-3 py-2 border rounded text-green-heinz-lighter border-green-light hover:text-white hover:border-white">
            <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
          </button>
        </div>
        <div class="menuitems w-full hidden flex-grow lg:flex lg:items-center lg:w-auto">
          <div v-if="isCustomerWebsite" class="text-base lg:flex-grow">
            <router-link tag="a" :to="{ path: '/' }" :class="{ active: $route.path == '/' }" class="block mt-4 lg:inline-block lg:mt-0 text-grey-light hover:text-white mr-4">Startseite</router-link>
            <router-link tag="a" :to="{ name: 'Shop', params: { hostUrl: hostUrl } }" :class="{ active: $route.name == 'Shop' }" class="block mt-4 lg:inline-block lg:mt-0 text-grey-light hover:text-white mr-4">Speisekarte</router-link>
            <router-link tag="a" :to="{ name: 'Warenkorb', params: { hostUrl: hostUrl } }" :class="{ active: $route.name == 'Warenkorb' }" class="block mt-4 lg:inline-block lg:mt-0 text-grey-light hover:text-white mr-4">Warenkorb</router-link>
            <router-link tag="a" :to="{ name: 'Oeffnungszeiten' }" :class="{ active: $route.name == 'Oeffnungszeiten' }" class="block mt-4 lg:inline-block lg:mt-0 text-grey-light hover:text-white mr-4">Öffnungszeiten</router-link>
            <router-link v-if="homedelivery" tag="a" :to="{ name: 'Lieferorte' }" :class="{ active: $route.name == 'Lieferorte' }" class="block mt-4 lg:inline-block lg:mt-0 text-grey-light hover:text-white mr-4">Liefergebiet</router-link>
          </div>
        </div>
      </nav>
      <div v-if="isLoggedIn && !user.item_activated" class="w-full bg-green-heinz border-b-2 border-grey-darkest text-center">
        <router-link tag="a" :to="{ name: 'Einstellungen' }" class="text-sm text-black no-underline">
          <nobr>Liebe(r) {{ user.item_firstname }},</nobr> <nobr>bitte aktiviere dein Benutzerkonto 🔜</nobr>
        </router-link>
      </div>
    </header>

    <section class="p-4 lg:p-8 bg-white">
      <modal adaptive class="z-50" name="userlogin" :clickToClose="true" height="auto" :scrollable="true">
        <h3 class="headline-extras">Anmeldung</h3>
        <div class="-mt-2 mb-6 text-sm">
          <strong>Du hast noch keinen Account?</strong>
          <a href="javascript:void(0)" @click="gotoRegistration()" class="text-black">
            Klicke hier um dich zu registrieren!
          </a>
        </div>

        <form v-on:submit.prevent="userLoginAction()">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-first-name">
            E-Mail Adresse
            <input v-model="loginData.email" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-first-name" type="text" autocomplete="email" placeholder="Deine E-Mail Adresse" />
          </label>

          <label class="block mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-first-name">
            Passwort
            <input v-model="loginData.password" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-first-name" type="password" placeholder="" />
          </label>
          <a v-on:click="userForgotPasswd()" href="javascript:void(0)" class="text-sm mt-0 no-underline text-grey-darker hover:text-black">Passwort vergessen?</a>

          <div class="flex w-full">
            <input type="button" v-on:click="userLoginAbort()" class="block w-full mt-4 shadow bg-grey text-white font-bold mt-2 py-2 px-4 rounded" value="abbrechen" />
            <div class="w-1/8"></div>
            <input type="submit" class="block w-full mt-4 shadow bg-green-heinz text-white font-bold mt-2 py-2 px-4 rounded" value="einloggen" />
          </div>
        </form>
      </modal>

      <div v-if="isHealthy || ignoreHealthyness" :class="{'contentLimiter' : hasMainContentLimiter}">
        <breadcrumb v-if="!isInsiteApp"></breadcrumb>
        <router-view/>
        <menuTracker/>
      </div>

      <div v-else class="contentLimiter">
        <h1>Wartungsarbeiten 🤯</h1>
        Wir sind gleich wieder für dich da.<br />
        Diese Seite aktualisiert sich automatisch in {{ secondsUntilReload }} Sekunden.
      </div>
    </section>

    <footer v-if="!isInsiteApp && !isPosApp" class="flex items-center justify-end flex-wrap lg:h-48 p-4 lg:p-8 pt-8 mb-8 bg-white">
      <div class="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
        <div class="contentLimiter text-sm lg:flex-grow bg-white rounded py-4 mb-8">

          <span class="block mt-4 lg:inline-block lg:mt-0 text-center ml-4 mr-4">Made with ♥ {{ (new Date()).getFullYear() }}</span>
          <a v-if="facebookUrl" :href="facebookUrl" class="block mt-4 lg:inline-block lg:mt-0 text-center text-grey-darker hover:text-black mr-4" target="_blank">Facebook</a>
          <a v-if="instagramUrl" :href="instagramUrl" class="block mt-4 lg:inline-block lg:mt-0 text-center text-grey-darker hover:text-black mr-4" target="_blank">Instagram</a>

          <router-link tag="a" :to="{ name: 'Impressum' }" class="block mt-4 lg:inline-block lg:mt-0 text-center text-grey-darker hover:text-black mr-4">Impressum</router-link>
          <router-link tag="a" :to="{ name: 'Datenschutz' }" class="block mt-4 lg:inline-block lg:mt-0 text-center text-grey-darker hover:text-black mr-4">Datenschutz</router-link>
          <router-link tag="a" :to="{ name: 'Agb' }" class="block mt-4 lg:inline-block lg:mt-0 text-center text-grey-darker hover:text-black mr-4">AGB</router-link>
          <router-link v-if="!isCustomerWebsite" tag="a" :to="{ name: 'AgbBusiness' }" class="block mt-4 lg:inline-block lg:mt-0 text-center text-grey-darker hover:text-black mr-4">AGB für Anbieter</router-link>
          <router-link v-if="!isCustomerWebsite" tag="a" :to="{ name: 'Informationen' }" class="block mt-4 lg:inline-block lg:mt-0 text-center text-grey-darker hover:text-black mr-4">Informationen für Anbieter</router-link>

        </div>
      </div>
    </footer>

    <v-dialog/>
    <couponcode></couponcode>
    <note></note>
  </div>
</template>

<script>
import endpoints from './endpoints'
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import Breadcrumb from './components/Breadcrumb.vue'
import Couponcode from './components/Couponcode.vue'
import MenuTracker from './components/MenuTracker.vue'
import Note from './components/Notecomponent.vue'
import AppBanner from "./components/AppBanner.vue";

export default {
  name: 'Pizzaheinz',

  data () {
    return {
      hostId: window.hostId,
      hostUrl: window.hostUrl,
      logoTitle: window.logoTitle,
      homedelivery: window.homedelivery,
      loginData: {
        email: '',
        password: ''
      },
      secondsUntilReload: 30
    }
  },

  computed: {
    ...mapGetters([
      'getSearchQuery',
      'user',
      'isLoggedIn'
    ]),

    isHealthy () {
      return window.healthy === 'true' || window.healthy === '1' || window.healthy.substring(0, 3) === '<?='
    },

    ignoreHealthyness () {
      return this.$route.name === 'Impressum' || this.$route.name === 'Datenschutz' || this.$route.name === 'Agb' || this.$route.name === 'AgbBusiness' || this.$route.name === 'Informationen'
    },

    hasMainContentLimiter () {
      if (![
        'Startseite',
        'Speisekarte'
      ].find(item => item === this.$route.name)) {
        return true
      }
    },

    isInsiteApp () {
      return new URL(location.href).searchParams.get('insite') !== null
    },

    instagramUrl () {
      return (typeof window.instagram !== 'undefined' && window.instagram ? window.instagram : false)
    },

    facebookUrl () {
      return (typeof window.facebook !== 'undefined' && window.facebook ? window.facebook : false)
    },

    templateClasses () {
      return (this.isInsiteApp ? 'isInsiteApp ' : '') + window.type
    }
  },

  created () {
    this.resetLocationFilter()
    this.getUserData()
    this.setHost()
    this.watchScrollTop()
    this.initWatchOfficeOrder()
    this.initReloadIfNotHealthy()
  },

  components: {
    'breadcrumb': Breadcrumb,
    'couponcode': Couponcode,
    'note': Note,
    'menuTracker': MenuTracker,
    AppBanner
  },

  methods: {
    ...mapActions([
      'initInterval',
      'updateBasket',
      'watchOfficeOrder',
      'getUserData',
      'login',
      'logout',
      'resetLocationFilter'
    ]),

    setHost () {
      if (isNaN(Number(window.hostId)) || Number(window.hostId) < 1) {
        axios.post(endpoints.gethostbyurl, { url: this.$route.params.hostUrl })
          .then(response => {
            window.hostId = response.data.id
            this.saveHost()
          })
      } else {
        this.saveHost()
      }
    },

    saveHost () {
      console.log('set host to ' + window.hostId)

      axios.post(endpoints.sethost + window.hostId, {})
        .catch(e => {
          this.errors.push('Der gewählte Anbieter konnte nicht ausgewählt werden 😭')
        })
    },

    initReloadIfNotHealthy () {
      if (this.isHealthy) return false

      window.setInterval(() => {
        this.secondsUntilReload -= 1

        if (this.secondsUntilReload < 1) {
          window.location.reload()
          this.secondsUntilReload = 0
        }
      }, 1000)
    },

    initWatchOfficeOrder () {
      window.setInterval(() => this.watchOfficeOrder(), 5000)
      this.watchOfficeOrder()
    },

    toggleMenu () {
      document.getElementsByClassName('menuitems')[0].classList.toggle('hidden')
    },

    watchScrollTop: function () {
      document.addEventListener('scroll', () => {
        if (window.scrollY > 100 || this.getSearchQuery !== '') {
          document.getElementsByTagName('body')[0].classList.add('scrolldown')
        } else {
          document.getElementsByTagName('body')[0].classList.remove('scrolldown')
        }
      })
    },

    userLogin () {
      this.$modal.show('userlogin')
    },

    userLoginAbort () {
      this.$modal.hide('userlogin')
    },

    userLoginAction (event) {
      if (event) event.preventDefault()
      this.login(this.loginData)
      this.$modal.hide('userlogin')
    },

    userLogout () {
      if (window.confirm('Bist du sicher, dass du dich ausloggen möchtest?')) {
        this.logout()
      }
    },

    userForgotPasswd () {
      this.$modal.hide('userlogin')
      this.$router.push({ name: 'Passwort' })
    },

    gotoRegistration () {
      this.$modal.hide('userlogin')
      this.$router.push({ name: 'Registrierung' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .logolink {
    cursor: pointer;
  }

  nav {
    .active {
      color: #FFF;
      font-weight: bold;
    }
  }

  .headbg {
    border-bottom: 3px solid transparent;
    transition: all 1s;
  }

  .loggedin {
    border-bottom: 3px solid $heinzGreen;
  }

  .heinzlogo {
    width: 200px;
  }

  .btn {
    @apply inline-block;
    @apply mr-4;
    @apply w-6;
    @apply h-6;
    @apply bg-green-heinz;
    @apply cursor-pointer;

    &:last-child {
      @apply mr-0;

      @screen lg {
        @apply mr-4;
      }
    }

    &-login {
      mask: url('/static/icons/login.svg') no-repeat center;
    }

    &-logout {
      mask: url('/static/icons/logout-1.svg') no-repeat center;
    }

    &-settings {
      mask: url('/static/icons/settings.svg') no-repeat center;
    }
  }

  .contentLimiter {
    @apply max-w-3xl;

    @screen xl {
      @apply mx-auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue